import { Drawer } from 'antd'
import { memo, useEffect, useState } from 'react'
import { ReactComponent as CloseModalIcon } from '@/assets/icons/closeModal.svg'
import style from './index.module.scss'

import SelectNetwork from './SelectNetwork'
import SweepStrategy from './SweepStrategy'
import { useTranslation } from '@/services/i18n'
import { SweepConfig, SweepNetwork } from '@/services/apis/sweep/models'
import { AutoSweepRuleDetailModel } from '@/services/apis/policy/model'

interface Props {
  open: boolean
  onClose: () => void
  data?: AutoSweepRuleDetailModel
  baseConfig: SweepConfig
}

const SweepDrawer = memo<Props>(({ open, onClose, data, baseConfig }) => {
  const [step, setStep] = useState(0)
  const [selectedNetwork, setSelectedNetwork] = useState<SweepNetwork>()
  const { t } = useTranslation()
  const resetState = () => {
    setSelectedNetwork(undefined)
    setStep(0)
  }
  const handleClose = () => {
    resetState()
    onClose()
  }
  useEffect(() => {
    if (data) {
      const { networkKey, networkName, networkLogo, blockchainTypeName } = data
      setSelectedNetwork({
        networkKey,
        networkName,
        networkLogo,
        blockchainTypeName,
        existsAutoSweepPolicy: true,
      })
      setStep(1)
    }
  }, [data])
  const isModify = !!data
  return (
    <Drawer
      title={
        isModify ? t('autoSweep.modifyAutoSweepStrategy') : t('autoSweep.addAutoSweepStrategy')
      }
      placement="right"
      open={open}
      closable={false}
      push={false}
      onClose={handleClose}
      extra={
        <div onClick={handleClose} className={style.closeIcon}>
          <CloseModalIcon />
        </div>
      }
      footer={null}
      width={560}
      maskClosable={false}
      destroyOnClose={true}
    >
      {step === 0 ? (
        <SelectNetwork
          onOk={network => {
            setStep(1)
            setSelectedNetwork(network)
          }}
          onCancel={handleClose}
        />
      ) : (
        <SweepStrategy
          defaultNetwork={selectedNetwork}
          onClose={handleClose}
          data={data}
          baseConfig={baseConfig}
        />
      )}
    </Drawer>
  )
})

export default SweepDrawer
